<template>
	<v-dialog
		v-model="visible"
		max-width="600"
		persistent
	>
		<v-alert
			border="top"
			colored-border
			:color="color"
			class="mb-0 px-8 pt-6 pb-2"
		>
			<div class="context">
				<div class="message-row">
					<v-icon v-if="isWarning" class="warning-icon mr-3" :color="color">mdi-alert-outline</v-icon>
					<div class="message-texts" :class="{ 'message-texts-center': !isWarning }">
						<div v-for="(t, index) in text" :key="`t_${index}`" class="title-text">{{ t }}</div>
					</div>
				</div>
				<v-row class="mt-5 mx-0 mb-0" justify="center" align="center">
					<v-btn depressed :color="color" max-height="32" min-height="32" class="white--text" @click="$emit('ok')">OK</v-btn>
				</v-row>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'DialogNotice',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		text: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: '#00AAFD'
		},
		isWarning: {
			type: Boolean,
			default: false
		}
	}
}
</script>
<style lang="scss" scoped>
.context {
	display: flex;
	flex-flow: column nowrap;
}

.message-row {
	display: flex;
	align-items: flex-start;
}

.warning-icon {
	flex: 0 0 auto;
}

.message-texts {
	flex: 1 1 auto;
	min-width: 0;
}

.message-texts-center {
	text-align: center;
}
</style>
